import React, { Fragment } from "react";
import PropTypes from 'prop-types';
import { SelectInput, TextInput } from "../../../Helpers/Inputs";
import { InputMaskDate } from '../../../Helpers/Formatters';
import { VIRGIN_ISLANDS } from '../../../Helpers/Constants/States';
import GetStateListForAflac from '../Helpers/StateListForAflac';

export default function BeneficiaryForm(props) {

    const getBeneficiaryOptions = () => {
        const options = props.getListOfPlanIncludedPerson();
        options.push({ value: "New Individual", label: "New Individual" });
        return options;
    }

    const getRelationshipSelectOptions = () => {
        return (
            [
                { value: "Aunt", label: "Aunt" },
                { value: "Brother-in-Law", label: "Brother-in-Law" },
                { value: "Business Partner", label: "Business Partner" },
                { value: "Child", label: "Child" },
                { value: "Common Law Spouse", label: "Common Law Spouse" },
                { value: "Cousin", label: "Cousin" },
                { value: "Custodian UTMA/UGMA", label: "Custodian UTMA/UGMA" },
                { value: "Daughter-in-Law", label: "Daughter-in-Law" },
                { value: "Domestic Partner", label: "Domestic Partner" },
                { value: "Ex-Spouse", label: "Ex-Spouse" },
                { value: "Father-in-Law", label: "Father-in-Law" },
                { value: "Fiance", label: "Fiance" },
                { value: "Friend", label: "Friend" },
                { value: "Grandchild", label: "Grandchild" },
                { value: "Grandparent", label: "Grandparent" },
                { value: "Mother-in-Law", label: "Mother-in-Law" },
                { value: "Nephew", label: "Nephew" },
                { value: "Niece", label: "Niece" },
                { value: "Parent", label: "Parent" },
                { value: "Sibling", label: "Sibling" },
                { value: "Sister-in-Law", label: "Sister-in-Law" },
                { value: "Son-in-Law", label: "Son-in-Law" },
                { value: "Spouse", label: "Spouse" },
                { value: "Step Parent", label: "Step Parent" },
                { value: "Step Child", label: "Step Child" },
                { value: "Step Sibling", label: "Step Sibling" },
                { value: "Uncle", label: "Uncle" },
            ]
        )
    }

    const getPercentageOption = () => {
        const data = [];

        for (let i = 1; i <= 100; i++) {
            data.push({ value: i, label: `${i}%` });
        }
        return data;
    }

    const beneType = props.beneType, state = props.state;

    const onFieldChange = (field, value) => {
        // call onChange with the whole updated form
        props.onChange({ ...props.formState, [field]: value })
    }

    // manually call setValue for fields that don't play nice with react-hook-form register
    const handleValueChange = (field, value, longFieldName) => {
        onFieldChange(field, value);
        props.trigger(longFieldName);
    }
    const handleChangeBenificiary = (value, longFieldName) => {
        props.trigger(longFieldName);
        props.onSelectBeneficiary(value, props.index);
    }

    return (
        <div>
            <p className="section-title"><b>{beneType === "beneficiaries" ? 'Beneficiary' : 'Contingent Beneficiary'} {props.index + 1}</b></p>

            {beneType === "beneficiaries" &&
                <Fragment>

                    <div className="mb-3">
                        <SelectInput
                            name={`${beneType}[${props.index}].selectPrimary`}
                            id={`${beneType}[${props.index}].selectPrimary`}
                            value={props.formState.selectPrimary}
                            onChange={e => {
                                handleChangeBenificiary(e.target.value, `${beneType}[${props.index}].selectPrimary`);
                            }}
                            label="Select Primary Beneficiary"
                            selectOptions={getBeneficiaryOptions()}
                            hideEmptyOption={true}
                        />
                    </div>

                </Fragment>
            }

            {beneType === "contBeneficiaries" &&
                <Fragment>
                    <div className="mb-3">
                        <SelectInput
                            name={`${beneType}[${props.index}].selectContingent`}
                            id={`${beneType}[${props.index}].selectContingent`}
                            value={props.formState.selectContingent}
                            onChange={e => {
                                handleChangeBenificiary(e.target.value, `${beneType}[${props.index}].selectContingent`);
                            }}
                            label="Contingent Beneficiary"
                            selectOptions={getBeneficiaryOptions()}
                        />
                    </div>

                </Fragment>
            }

            {((beneType === "beneficiaries" && props.formState.selectPrimary === "New Individual") || (beneType === "contBeneficiaries" && props.formState.selectContingent === "New Individual")) &&
                <Fragment>
                    <div className="mb-3">
                        <TextInput
                            name={`${beneType}[${props.index}].firstName`}
                            id={`${beneType}[${props.index}].firstName`}
                            label="First Name"
                            value={props.formState.firstName}
                            onChange={(e) => handleValueChange('firstName', e.target.value, `${beneType}[${props.index}].firstName`)}
                            inputProps={{
                                maxLength: 20,
                            }}
                        />
                    </div>

                    <div className="mb-3">
                        <TextInput
                            name={`${beneType}[${props.index}].middleInitial`}
                            id={`${beneType}[${props.index}].middleInitial`}
                            label="Middle Initial"
                            value={props.formState.middleInitial}
                            onChange={(e) => handleValueChange('middleInitial', e.target.value, `${beneType}[${props.index}].middleInitial`)}
                            inputProps={{
                                maxLength: 4,
                            }}
                        />
                    </div>

                    <div className="mb-3">
                        <TextInput
                            name={`${beneType}[${props.index}].lastName`}
                            id={`${beneType}[${props.index}].lastName`}
                            label="Last Name"
                            value={props.formState.lastName}
                            onChange={(e) => handleValueChange('lastName', e.target.value, `${beneType}[${props.index}].lastName`)}
                            inputProps={{
                                maxLength: 50,
                            }}
                        />
                    </div>

                    <div className="mb-3">
                        <TextInput
                            name={`${beneType}[${props.index}].dateOfBirth`}
                            id={`${beneType}[${props.index}].dateOfBirth`}
                            label="Date of Birth"
                            value={props.formState.dateOfBirth}
                            onChange={(e) => handleValueChange('dateOfBirth', e.target.value, `${beneType}[${props.index}].dateOfBirth`)}
                            InputProps={{
                                inputComponent: InputMaskDate,
                            }}
                        />
                    </div>

                    <div className="mb-3">
                        <SelectInput
                            name={`${beneType}[${props.index}].relationship`}
                            id={`${beneType}[${props.index}].relationship`}
                            label="Relationship to Proposed Insured"
                            value={props.formState.relationship}
                            selectOptions={getRelationshipSelectOptions()}
                            onChange={(e) => handleValueChange('relationship', e.target.value, `${beneType}[${props.index}].relationship`)}
                        />
                    </div>
                </Fragment>
            }

            {state === VIRGIN_ISLANDS && ((beneType === "beneficiaries" && props.formState.selectPrimary !== "None") || (beneType === "contBeneficiaries" && props.formState.selectContingent !== "None" && props.formState.selectContingent !== "")) &&
                <Fragment>
                    <div className="mb-3">
                        <TextInput
                            name={`${beneType}[${props.index}].city`}
                            id={`${beneType}[${props.index}].city`}
                            label="City"
                            value={props.formState.city}
                            onChange={(e) => handleValueChange('city', e.target.value, `${beneType}[${props.index}].city`)}
                            inputProps={{
                                maxLength: 40,
                            }}
                        />
                    </div>

                    <div className="mb-3">
                        <SelectInput
                            name={`${beneType}[${props.index}].state`}
                            id={`${beneType}[${props.index}].state`}
                            label="State"
                            value={props.formState.state}
                            onChange={e => handleValueChange('state', e.target.value, `${beneType}[${props.index}].state`)}
                            selectOptions={GetStateListForAflac()}
                        />
                    </div>
                </Fragment>
            }

            {((beneType === "beneficiaries") || (beneType === "contBeneficiaries" && props.formState.selectContingent && props.formState.selectContingent !== "None")) &&
                <div className="mb-3">
                    <SelectInput
                        name={`${beneType}[${props.index}].percentage`}
                        id={`${beneType}[${props.index}].percentage`}
                        label="Percentage of Proceeds"
                        value={props.formState.percentage}
                        onChange={(e) => handleValueChange('percentage', e.target.value, `${beneType}[${props.index}].percentage`)}
                        selectOptions={getPercentageOption()}
                    />
                </div>
            }
        </div>
    )
}

BeneficiaryForm.propTypes = {
    formState: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    beneType: PropTypes.string.isRequired
}
